import { Record } from 'immutable'


export default schema => {
  return class extends Record( schema ) {
    update( attrs ) {
      return this.withMutations( state => {
        for ( const a in attrs ) {
          state = state.set( a, attrs[a])
        }

        return state
      })
    }
  }
}
